export type PasswordPolicy =
  | 'length'
  | 'upper'
  | 'lower'
  | 'number'
  | 'special';

export type PasswordPolicyCheck = {
  ok: boolean;
  missing: PasswordPolicy[];
};

export const checkPasswordForSignup = (
  password: string,
): PasswordPolicyCheck => {
  const pwd = password ?? '';
  const missing: PasswordPolicy[] = [];

  if (pwd.length < 12) missing.push('length');
  if (!/[A-Z]/.test(pwd)) missing.push('upper');
  if (!/[a-z]/.test(pwd)) missing.push('lower');
  if (!/[0-9]/.test(pwd)) missing.push('number');
  if (!/[^A-Za-z0-9]/.test(pwd)) missing.push('special');

  return { ok: missing.length === 0, missing };
};
